import { configureApiCalls } from "Api/Api";
import i18next from "i18next";
import * as React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { resetUser } from "State/Auth/AuthReducer";
import { getResourcePath, Resources } from "Translations/Resources";

type Props = { error403: string; error404: string };

export const ApiCalls: React.FunctionComponent<Props> = ({
  error403,
  error404,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  configureApiCalls({
    jwtKey: "jwtToken",
    onResponse: r => {
      if (r.status === 401) {
        dispatch(resetUser());
      } else if (r.status === 404) {
        history.replace(error404);
      } else if (r.status === 403) {
        history.replace(error403);
        dispatch(resetUser());
      } else if (r.status === 503) {
        toast.error(i18next.t(getResourcePath(Resources.Errors.APIError[503])));
      } else if (r.status === 500) {
        toast.error(i18next.t(getResourcePath(Resources.Errors.APIError[500])));
      }
    },
  });

  return <></>;
};
